export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://cost-curious-api.herokuapp.com';



// WEBPACK FOOTER //
// ./src/config.js